import { twJoin } from "tailwind-merge";

type HorizontalProps = {
  orientation?: "horizontal";
  spacing?: `my-${number}`;
  width?: `w-${number}` | "w-full" | "w-px";
  variant?: "dark" | "light";
};

type VerticalProps = {
  orientation?: "vertical";
  spacing?: `mx-${number}` | `my-${number}`;
  height?: `h-${number}` | "h-full" | "h-px";
  variant?: "dark" | "light";
};

const isHorizontal = (
  props: HorizontalProps | VerticalProps,
): props is HorizontalProps => {
  return !props.orientation || props.orientation === "horizontal";
};

export const Divider: React.FC<HorizontalProps | VerticalProps> = (props) => {
  const variant = props.variant ?? "light";

  return (
    <hr
      className={twJoin(
        "rounded-full",
        variant === "dark" ? "bg-gray-200" : "bg-gray-100",
        isHorizontal(props) ? "h-px" : "w-px",
        isHorizontal(props)
          ? (props.width ?? "w-full")
          : (props.height ?? "h-full"),
        props.spacing,
      )}
    />
  );
};
